

var closings = 		[

			{
			"name":"Adair Public Schools"
			,"type":1
			,"date":1535456092
			,"status":"Closed"
			}

		,
			{
			"name":"Bartlesville Public Schools"
			,"type":1
			,"date":1535456212
			,"status":"Closed Wednesday"
			}

		,
			{
			"name":"Beggs Public Schools"
			,"type":1
			,"date":1535456212
			,"status":"Opening 1 1/2 hours late"
			}

		,
			{
			"name":"Ponca City Public Schools"
			,"type":1
			,"date":1535456212
			,"status":"Closing at 3:00 PM"
			}

		,
			{
			"name":"Boys &amp; Girls Club of Bartlesville"
			,"type":3
			,"date":1535457832
			,"status":"Closing at 2:15 PM"
			}

		,
			{
			"name":"Catholic Charities"
			,"type":3
			,"date":1535457832
			,"status":"Closed Thursday"
			}

		,
			{
			"name":"First Baptist Church Stilwell"
			,"type":2
			,"date":1535457832
			,"status":"Opening 3 hours late"
			}

		,
			{
			"name":"First United Methodist Church of Owasso"
			,"type":2
			,"date":1535457832
			,"status":"Closed"
			}


		]

export default closings



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/testClosings.js